import { FC } from 'react';
import { KTIcon } from '../../../../../../_metronic/helpers';
import { ThemeModalState } from '../../themes-grid/model/types';

interface Props {
	openModal: ThemeModalState;
	handleModalClose: () => void;
}

const ThemeEditModalHeader: FC<Props> = ({ openModal, handleModalClose }) => {
	const title =
		openModal.type === 'create'
			? 'Новая тема'
			: openModal.type === 'edit'
			? 'Редактировать тему'
			: 'Удалить тему';

	return (
		<div className='modal-header'>
			<h2 className='fw-bolder'>{title}</h2>
			<div
				className='btn btn-icon btn-sm btn-primary btn-active-icon-light'
				onClick={handleModalClose}
				data-kt-users-modal-action='close'
				style={{ cursor: 'pointer' }}
			>
				<KTIcon iconName='cross' className='fs-1' />
			</div>
		</div>
	);
};

export { ThemeEditModalHeader };
